import { MassiaTabulatorModule } from './massia.tabulator.module';
import MassiaTabulatorController from './massia.tabulator.controller';
import GridConfigAdapterService from './adapter/grid-config-adapter.service';
import { MassiaActionDispatcher } from './massia.action.dispatcher';

// Enregistrement des services
MassiaTabulatorModule.service('GridConfigAdapterService', GridConfigAdapterService).service('MassiaActionDispatcher', MassiaActionDispatcher);

// Enregistrement du composant
MassiaTabulatorModule.component('massiaTabulator', {
    bindings: {
        dataset: '<?', //Tableau de données à afficher  (inutile pour tabulator remote, c'est tabulator qui fait la requete back)
        gridConfig: '<?', //Configuration Tabulator Massia  (Utilisé quand on ne passe pas par serverGridConfig)
        gridApi: '=?', //Permet au parent de piloter la grille (ex: forcer un rechargement)
        options: '<?', //Options Tabulator brutes à merger dans la configuration finale (ex: { height: '400px', layout: 'fitData' })
        onCellEdited: '&' //Callback déclenché quand une cellule éditable est modifiée. Reçoit $event : { row, field, value }
    },
    template: require('./massia.tabulator.tpl.html'),
    controller: MassiaTabulatorController
});

export default MassiaTabulatorModule.name;
